import { captureMessage } from '@sentry/browser';
import { DISCORD_CHANNEL } from '@colonist/consts';
import { DiscordMountPopupType } from '../../../../shared/DiscordActivityTypes.ts';
import { showSimpleDialog } from '../ui_popup/showSimpleDialog.ts';
import { navigateToPage } from '../ui_utils/ClientUtils.ts';
export class DiscordPopupFromMountHandler {
    createPopup(data) {
        if ((data === null || data === void 0 ? void 0 : data.popupType) == undefined) throw new Error('Popup type is missing');
        const popupType = data.popupType;
        switch(popupType){
            case DiscordMountPopupType.UserAlreadyHasMembershipError:
                this.createUserAlreadyHasMembershipError(data);
                break;
            default:
                return;
        }
    }
    createUserAlreadyHasMembershipError(data) {
        if (data.error == undefined) return;
        const alreadyHasMembershipTitle = {
            key: 'strings:popups.errors.discordActiveMembershipError.title'
        };
        const alreadyHasMembershipBody = {
            key: 'strings:popups.errors.discordActiveMembershipError.body'
        };
        showSimpleDialog({
            title: alreadyHasMembershipTitle,
            body: alreadyHasMembershipBody,
            confirmLabel: {
                key: 'strings:colonistCommon.buttons.discord'
            },
            onConfirm: ()=>navigateToPage(DISCORD_CHANNEL, true)
        });
        this.sendUserAlreadyHasMembershipReportToSentry(data.error);
    }
    sendUserAlreadyHasMembershipReportToSentry(error) {
        var _this_contentFrameCommunicationHandler_serverProfile;
        var _this_contentFrameCommunicationHandler_serverProfile_username;
        const data = {
            discordUsername: (_this_contentFrameCommunicationHandler_serverProfile_username = (_this_contentFrameCommunicationHandler_serverProfile = this.contentFrameCommunicationHandler.serverProfile) === null || _this_contentFrameCommunicationHandler_serverProfile === void 0 ? void 0 : _this_contentFrameCommunicationHandler_serverProfile.username) !== null && _this_contentFrameCommunicationHandler_serverProfile_username !== void 0 ? _this_contentFrameCommunicationHandler_serverProfile_username : 'unknown username',
            errorCode: error.code,
            errorMessage: error.message
        };
        captureMessage(`Discord Error | ${error.message}`, {
            level: 'error',
            extra: {
                data: JSON.stringify(data)
            }
        });
    }
    constructor(contentFrameCommunicationHandler){
        this.contentFrameCommunicationHandler = contentFrameCommunicationHandler;
    }
}
